const AUTH_REDIRECT_PATH_KEY = "post_login_redirect_path";

const isRedirectablePath = (path) => {
  return (
    typeof path === "string" &&
    path.startsWith("/") &&
    !path.startsWith("//") &&
    path !== "/" &&
    path !== "/accessDenied"
  );
};

export const getCurrentAppPath = () => {
  if (typeof window === "undefined") {
    return "";
  }

  return `${window.location.pathname}${window.location.search}${window.location.hash}`;
};

export const persistAuthRedirectPath = (path = getCurrentAppPath()) => {
  if (!isRedirectablePath(path)) {
    return;
  }

  try {
    sessionStorage.setItem(AUTH_REDIRECT_PATH_KEY, path);
  } catch (error) {
    console.error("Unable to store auth redirect path:", error);
  }
};

export const consumeAuthRedirectPath = () => {
  try {
    const redirectPath = sessionStorage.getItem(AUTH_REDIRECT_PATH_KEY);

    sessionStorage.removeItem(AUTH_REDIRECT_PATH_KEY);

    return isRedirectablePath(redirectPath) ? redirectPath : "";
  } catch (error) {
    console.error("Unable to read auth redirect path:", error);
    return "";
  }
};